import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios

// La URL del API viene de VUE_APP_API_URL, segun el entorno:
//   produccion -> https://api.kbpwallet.net/api/v1/        (.env.production / --mode production)
//   staging    -> https://api-wallet.kingconnections.net/api/v1/  (.env.staging / --mode staging)
//   local      -> define VUE_APP_API_URL en .env.local
axiosIns.defaults.baseURL = process.env.VUE_APP_API_URL
// axiosIns.defaults.baseURL = 'https://6a5c-2a02-9130-8422-898d-f3a4-351c-2d09-2d76.eu.ngrok.io/api/v1/'
Vue.prototype.$http = axiosIns

export default axiosIns
